import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Aos from "aos";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { MdPlayArrow } from "react-icons/md";
import Description from "./Description";
import "./tab.scss";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: "100%",
  },
  tabs: {
    padding: "20px",
    margin: "10px",
    background: "#f9f9f9",
    width: "100%",
  },
}));

export default function VerticalTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  Aos.init({
    delay: 500,
    once: true,
  });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/gemological-education/courses"
        />
        <title>Gemological Courses | Galaxy Gemological Institute</title>
        <meta
          name="description"
          content="GGI offers comprehensive gemological courses that teach you everything you need to know about gemstones, from identification and grading to jewelry design. visit now!"
        />
      </Helmet>
      <div className="parentTab">
        <div className="innerParentTab">
          <div className="TabSection">
            <div className={classes.tabs}>
              <Tabs
                data-aos="zoom-out-left"
                orientation="vertical"
                className="tabpanel"
                variant="scrollable"
                value={value}
                onChange={handleChange}
              >
                <Tab
                  className="tabs"
                  data-aos="fade-down-left"
                  icon={<MdPlayArrow />}
                  label="Diamond Grading Course"
                  {...a11yProps(0)}
                />
                <Tab
                  className="tabs"
                  data-aos="fade-down-left"
                  icon={<MdPlayArrow />}
                  label="Gem Identification Course"
                  {...a11yProps(1)}
                />
                <Tab
                  className="tabs"
                  data-aos="fade-down-left"
                  icon={<MdPlayArrow />}
                  label="Manual Jewellery Designing"
                  {...a11yProps(2)}
                />
                <Tab
                  className="tabs"
                  data-aos="fade-down-left"
                  icon={<MdPlayArrow />}
                  label="Computer Aided Designing"
                  {...a11yProps(3)}
                />
              </Tabs>
            </div>
          </div>
          <TabPanel value={value} index={0}>
            <Description
              image={
                // "https://res.cloudinary.com/dvnlhqs1k/image/upload/v1662654356/depositphotos_448398260-stock-photo-large-polished-round-cut-diamond_ftlpvd.webp"
                "https://res.cloudinary.com/ggi/image/upload/v1637903437/sl12_em1t40.webp"
              }
              heading={"Diamond Grading Course"}
              mainText={{
                heading: "",
                paragraph: `A detailed course on diamond and diamond grading. The course will cover all aspects of diamonds including the world famous 4C’s. GGI offers diamond grading course on regular basis which covers the following topics:`,
              }}
              content={[
                {
                  paragraph: "1. Diamond Essentials.",
                },
                {
                  paragraph: "2. Diamond Formation & Properties.",
                },
                {
                  paragraph: "3. Diamond Exploration & Mining.",
                },
                {
                  paragraph: "4. Diamond Cut.",
                },
                {
                  paragraph: "5. Diamond Color.",
                },
                {
                  paragraph: "6.  Diamond Clarity.",
                },
                {
                  paragraph: "7.  Diamond Carat Weight.",
                },
                {
                  paragraph: "8.  Synthetic Diamonds.",
                },
                {
                  paragraph: "9.  Diamond Treatments.",
                },
                {
                  paragraph: "10.  The Diamond Market.",
                },
                {
                  paragraph: "11.  Rapaport Wholesale Prices.",
                },
                {
                  paragraph: "12.  Diamond Simulants.",
                },
                {
                  paragraph: "13.  Synthetic Moissanite.",
                },
                {
                  paragraph: "14.  Selling Tools.",
                },
              ]}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Description
              image={
                "https://res.cloudinary.com/ggi/image/upload/v1637903399/Course_GemId_ojseth.webp"
              }
              heading={"Gem Identification Course"}
              mainText={{
                heading: "",
                paragraph:
                  "This is a comprehensive course including all the parameters of identifying natural, synthetic and treated gemstones. Students practice on a wide variety of stones collected from different parts of the world. The course covers the following topics:",
              }}
              content={[
                {
                  paragraph: "1. Introduction to gemology.",
                },
                {
                  paragraph: "2. Geology and gems formation.",
                },
                {
                  paragraph: "3. Gem deposits and mining.",
                },
                {
                  paragraph: "4. Physical properties of gemstone.",
                },
                {
                  paragraph: "5. Visual observation of gemstone.",
                },
                {
                  paragraph: "6.  Gemological Instruments.",
                },
                {
                  paragraph: "7.  Inclusion in gemstones.",
                },
                {
                  paragraph: "8.  Synthetic gemstone and their formation.",
                },
                {
                  paragraph: "9.  Treatments of gemstone.",
                },
              ]}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Description
              image={
                "https://res.cloudinary.com/ggi/image/upload/v1637903388/Course_Manual_akufrq.webp"
              }
              heading={"Manual Jewellery Designing"}
              mainText={{
                heading: "",
                paragraph:
                  "Introduction to jewellery and its components such as; drawing,illustration of faceted and non-faceted gemstones, setting in jewellery, texture in metals, gold calculation and budgeting.  GGI offers Manual Jewellery Designing course on regular basis which covers the following	topics:",
              }}
              content={[
                // {
                // 	heading: "GGI",
                // 	paragraph: `Galaxy gemological institute has been established to cater to the need of Pakistani gems and
                // 	jewellery industry`
                // },
                // {
                // 	heading: "VISION",
                // 	paragraph: `To be a leading source for all knowledge and expertise in gems and jewellery.`
                // },
                // {
                // 	heading: "MISSION",
                // 	paragraph: `Our mission is to develop the industry by sharing gem knowledge, grading techniques and
                // 	expertise, and to provide awareness to the local manufacturers about international standards of
                // 	jewellery manufacturing in order to enhance their ability to adopt modern techniques of jewelry
                // 	manufacturing and to set them at par with international standards.`
                // },
                // {
                // 	// heading: "MANUAL JEWELLERY DESIGNING COURSE",
                // 	paragraph: `Introduction to jewellery and its components such as; drawing, illustration of faceted and non-
                // 	faceted gemstones, setting in jewellery, texture in metals, gold calculation and budgeting`
                // }
                {
                  paragraph: "1. Introduction to Jewellery Designing.",
                },
                {
                  paragraph: "2. History of Jewellery Design.",
                },
                {
                  paragraph: "3. Cutting Styles of Gemstones.",
                },
                {
                  paragraph: "4. Shapes of Gemstone.",
                },
                {
                  paragraph: "5. Shading with graphite pencil.",
                },
                {
                  paragraph: "6. Color.",
                },
                {
                  paragraph: "7. Color tone & its concept.",
                },
                {
                  paragraph: "8. Shading of faceted Gemstones.",
                },
                {
                  paragraph: "9. Shading of Cabochons.",
                },
                {
                  paragraph: "10.  Shading of transparent & opaque stones.",
                },
                {
                  paragraph: "11.  Coloring of Pearls.",
                },
                {
                  paragraph: "12.  Color Rendering & its concept.",
                },
              ]}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Description
              image={
                // "https://res.cloudinary.com/ggi/image/upload/v1637903437/sl12_em1t40.webp"
                // "https://res.cloudinary.com/ggi/image/upload/v1637903388/Course_Computer_kz7pee.webp"
                "https://res.cloudinary.com/ggi/image/upload/v1663157784/ztxdom_lucafa.jpg"
              }
              heading={"Computer Aided Designing"}
              mainText={{
                heading: "",
                paragraph:
                  "The course is modified according to the technical requirement of the jewellery designs in Pakistan. The course is divided into three modules;",
              }}
              content={[
                {
                  paragraph: "1. 2D modelling (Macromedia Freehand).",
                },
                {
                  paragraph: "2. 3D basic (Rhinoceros).",
                },
                {
                  paragraph: "3. 3D advance (Matrix).",
                },
                {
                  paragraph:
                    "It consists of all necessary tools required to teach students how to build a jewellery pattern ready to be casted.",
                },
              ]}
            />
          </TabPanel>
        </div>
      </div>
      {/* </Helmet> */}
    </div>
  );
}
